import { createApi } from '@reduxjs/toolkit/query/react'

import { PROXY_API_V1_URL, ontologyBaseQuery } from '../core'
import type { GetUsageSummaryArgs, UsageSummaryResponse } from './types'

export const usageAnalyticsApi = createApi({
  reducerPath: 'usageAnalyticsApi',
  baseQuery: ontologyBaseQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  tagTypes: ['UsageSummary'],
  endpoints: (builder) => ({
    getUsageSummary: builder.query<UsageSummaryResponse, GetUsageSummaryArgs>({
      query: ({ from, to }) => ({
        url: `${PROXY_API_V1_URL}/usage-events/summary`,
        params: { from, to }
      }),
      providesTags: [{ type: 'UsageSummary', id: 'CURRENT' }]
    })
  })
})

export const { useGetUsageSummaryQuery } = usageAnalyticsApi
